window.addEventListener("load", function () {
  const versionBtn = document.getElementById("version-selector");
  versionBtn?.addEventListener("click", function () {
    versionBtn.focus();
  });
});
